import React from "react";
import { Modal, Typography, Avatar, Tag, Divider, Row, Col, Space } from "antd";
import {
  GiftOutlined,
  TrophyOutlined,
  CalendarOutlined,
  DatabaseOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Title, Text } = Typography;

const ORANGE = "#e2700d";

const ViewReward = ({ open, onClose, reward }) => {
  if (!reward) return null;

  const {
    name,
    description,
    pointsRequired,
    stock,
    expiryDate,
    isActive,
    createdAt,
    updatedAt,
  } = reward;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={650}
      bodyStyle={{ background: "#fff", padding: 24 }}
      closeIcon={<span style={{ color: ORANGE, fontSize: 18 }}>×</span>}
    >
      {/* 🔹 HEADER */}
      <Row gutter={16} align="middle">
        <Col>
          <Avatar
            size={64}
            icon={<TrophyOutlined />}
            style={{ backgroundColor: ORANGE }}
          />
        </Col>

        <Col flex="auto">
          <Title level={4} style={{ marginBottom: 0 }}>
            Reward Details
          </Title>
          <Text type="secondary">
            Created on {moment(createdAt).format("DD MMM YYYY, hh:mm A")}
          </Text>
        </Col>

        <Col>
          {isActive ? (
            <Tag color="green">Active</Tag>
          ) : (
            <Tag color="red">Inactive</Tag>
          )}
        </Col>
      </Row>

      <Divider />

      {/* 🔹 BASIC INFO */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        Reward Information
      </Divider>

      <Space direction="vertical" size={6}>
        <Text strong>{name}</Text>
        <Text type="secondary">{description || "-"}</Text>
      </Space>

      <Divider />

      {/* 🔹 STATS */}
      <Row gutter={0}>
        <Col span={12}>
          <Text>
            <GiftOutlined style={{ color: ORANGE }} /> Points Required
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            {pointsRequired?.toLocaleString()}
          </Title>
        </Col>

        <Col span={12}>
          <Text>
            <DatabaseOutlined style={{ color: ORANGE }} /> Stock Available
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            {stock}
          </Title>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 EXPIRY & STATUS */}
      <Row gutter={0}>
        <Col span={12}>
          <Text>
            <CalendarOutlined style={{ color: ORANGE }} /> Expiry Date
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            {expiryDate ? moment(expiryDate).format("DD MMM YYYY") : "-"}
          </Title>
        </Col>

        <Col span={12}>
          <Text>
            {isActive ? (
              <CheckCircleOutlined style={{ color: ORANGE }} />
            ) : (
              <CloseCircleOutlined style={{ color: ORANGE }} />
            )}{" "}
            Status
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            {isActive ? "Enabled" : "Disabled"}
          </Title>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 META INFO */}
      <Text type="secondary" style={{ fontSize: 12 }}>
        Last Updated: {moment(updatedAt).format("DD MMM YYYY, hh:mm A")}
      </Text>
    </Modal>
  );
};

export default ViewReward;
